import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';
import { useContext } from 'react';

import { useFilesContext } from '../../../../context/FilesProvider';
import LoaderContext from '../../../../context/LoaderProvider';
import { postFilesRequestSDS } from '../../../../services/serviceRequestAttachment';
import { generateRequestTemplate } from '../../../../adapters/requestTemplate/requestTemplateAdapter';
import useToast from '../../../../hooks/useToast';

const ModalPublicSwitchTemplate = ({
  showModalEditPublicTemplate,
  setShowModalEditPublicTemplate,
  toPublic,
  id
}) => {
  const { dataAdjuntos } = useFilesContext();
  const { values } = useFormikContext();
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const editTemplate = async () => {
    try {
      setLoader(true);
      const response = await generateRequestTemplate(values, dataAdjuntos, id);

      // If a new service was added and attachments were added to it
      if (dataAdjuntos.some((adj) => !adj.serviceRequestId)) {
        // Dismiss persisted Services
        const newAccordions = values?.accordions.filter((acc) => !acc.templeteRequestId);
        // Dismiss persisted service ids
        const newRequestId = response?.solicitudes.filter(
          (sol) => !values?.accordions.some((acc) => acc.templeteRequestId === sol.id)
        );

        await postFilesRequestSDS(newAccordions, newRequestId);
      }

      setNewToast({
        type: 'SUCCESS',
        message: response.mensaje
      });
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => {
        setShowModalEditPublicTemplate(false);
      }}
      primaryAction={() => {
        editTemplate();
        setShowModalEditPublicTemplate(false);
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => {
        setShowModalEditPublicTemplate(false);
      }}
      secondaryActionLabel="Cancelar"
      show={showModalEditPublicTemplate}
      size="lg"
      title="Editar visibilidad de la plantilla de solicitud"
    >
      <p>
        {toPublic
          ? '¿Estás seguro de que deseas compartir públicamente la plantilla?'
          : '¿Estás seguro de que deseas no compartir públicamente la plantilla?'}
      </p>
    </ModalGeneric>
  );
};

ModalPublicSwitchTemplate.propTypes = {
  showModalEditPublicTemplate: PropTypes.bool.isRequired,
  toPublic: PropTypes.bool.isRequired,
  setShowModalEditPublicTemplate: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};

export default ModalPublicSwitchTemplate;
